var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuzhen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "04_\u590D\u8BCA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.78,16h-48a4,4,0,0,0-4,4V52a4,4,0,0,0,4,4h48a4,4,0,0,0,4-4V20A4,4,0,0,0,55.78,16Zm0,36h-48V20h48Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.52,13.91a2,2,0,0,0,2-2v-4H42.05v4a2,2,0,0,0,4,0v-4a4,4,0,0,0-4-4H21.52a4,4,0,0,0-4,4v4A2,2,0,0,0,19.52,13.91Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.85,38.37h6v6a2,2,0,0,0,4,0v-6h6a2,2,0,0,0,0-4h-6v-6a2,2,0,1,0-4,0v6h-6a2,2,0,0,0,0,4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuzhen);
export default __webpack_public_path__ + "static/media/fuzhen.9458a565.svg";
export { ForwardRef as ReactComponent };